import React, { useContext, useEffect, useState } from "react";
import strings from "../../utils/property-file/officeTiming.json";
import InputMask from "react-input-mask";
import moment from "moment";
import { OfficeFormContext } from "../officeFormContext";
import PropTypes from "prop-types";

export default function InputTimeBtn(props) {
    const [toggle, setToggle] = useState(true);
    const { officeFormData, setOfficeFormData } = useContext(OfficeFormContext);
    const [startTime, setStartTime] = useState(officeFormData[props.index]?.startTime || '');
    const [endTime, setEndTime] = useState(officeFormData[props.index]?.endTime || '');
    const [lateTime, setLateTime] = useState(officeFormData[props.index]?.lateTime || '');
    const [msg, setMsg] = useState("");
    const [dspTime, setDspTime] = useState("");
    let fromTime = moment(startTime, "hh:mm");
    let toTime = moment(endTime, "hh:mm");
    let xLateTime = moment(lateTime, "hh:mm");
    let timeCalc = moment.duration(toTime.diff(fromTime));
    const [day, setsDay] = useState(officeFormData[props.index]?.day || '');
    useEffect(() => {
        setToggle(day === '')
        diffTime();
    }, []);

    const diffTime = () => {
        setMsg('')
        setDspTime(false)
        const showDiffTime = timeCalc.hours() + strings.hour + timeCalc.minutes() + strings.min;
        let startTime = fromTime.format('HH:mm')
        let endTime = toTime.format('HH:mm')
        let lateTime = xLateTime.format('HH:mm')
        if (startTime === strings.invalidDate) {
            startTime = ''
        }
        if (endTime === strings.invalidDate) {
            endTime = ''
        }
        if (lateTime === strings.invalidDate) {
            lateTime = ''
        }
        if (startTime > endTime) {
            setMsg(strings.fromTimeError);
            setDspTime(false);
        }
        else {
            if (lateTime) {
                if (lateTime < startTime || lateTime > endTime) {
                    setMsg(strings.lateTimeError);
                    setDspTime(false);
                }
                else {
                    setDspTime(showDiffTime);
                    setMsg(false);
                }
            }
        }
    };
    function handleInputChange(value, setTime) {
        let array = value.split(":");
        setsDay(props.name);
        const updatedFormData = {
            ...officeFormData,
            [props.index]: {
                day: day,
                startTime: startTime,
                endTime: endTime,
                lateTime: lateTime,
            },
        };
        if (parseInt(array[0]) > 23) {
            setTime("");
            return;
        } else {
            setTime(value);
            setOfficeFormData(updatedFormData);
        }
        if (parseInt(array[1]) > 59) {
            setTime("");
            return;
        } else {
            setTime(value);
            setOfficeFormData(updatedFormData);
        }
    }
    const toggleInputFields = () => {
        const updateFormData = { ...officeFormData };
        delete updateFormData[props.index];
        setOfficeFormData(updateFormData);
        setToggle(!toggle);
    };

    return (
        <div>
            <div className="days-time-container">
                <input
                    className={toggle ? "day-btn" : "day-btn normal-state"}
                    type="button"
                    value={props.name}
                    onClick={() => {
                        toggleInputFields()
                        setStartTime([]);
                        setEndTime([]);
                        setLateTime([]);
                        diffTime();
                    }}
                />
                <InputMask
                    mask="99:99"
                    placeholder="HH:MM"
                    className={toggle ? "timing-input" : "timing-input active"}
                    disabled={toggle}
                    required="required"
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                    onBlur={(e) => {
                        handleInputChange(e.target.value, setStartTime)
                    }}
                />
                <InputMask
                    mask="99:99"
                    placeholder="HH:MM"
                    className={toggle ? "timing-input" : "timing-input active"}
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                    onBlur={(e) => {
                        handleInputChange(e.target.value, setEndTime)
                        diffTime();
                    }}
                    disabled={toggle}
                    required="required"
                />
                <InputMask
                    mask="99:99"
                    placeholder="HH:MM"
                    className={toggle ? "timing-input" : "timing-input active"}
                    value={lateTime}
                    onChange={(e) => setLateTime(e.target.value)}
                    onBlur={(e) => {
                        handleInputChange(e.target.value, setLateTime)
                        diffTime();
                    }}
                    disabled={toggle}
                    required="required"
                />
            </div>
            <div className={toggle ? "display-none" : "calculated-time"}>
                {dspTime != strings.timeError && dspTime}
                <span>{msg}</span>
            </div>
        </div>
    );
}

InputTimeBtn.propTypes = {
    index: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
};